import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-close_jax_95463e6d70830fa04098376ddd5dd2ea",
  "use": "ico-close_jax_95463e6d70830fa04098376ddd5dd2ea-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-close_jax_95463e6d70830fa04098376ddd5dd2ea\">\n<path d=\"M8.00038 6.72596L12.4495 2.27685L13.7228 3.5502L9.27373 7.99931L13.7235 12.4491L12.4502 13.7225L8.00038 9.27265L3.55058 13.7225L2.27724 12.4491L6.72704 7.99931L2.27793 3.5502L3.55127 2.27685L8.00038 6.72596Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol